export const FETCH_PORTS = 'routes/Ports/FETCH_PORTS'
export const FETCH_PORTS_SUCCESS = 'routes/Ports/FETCH_PORTS_SUCCESS'
export const FETCH_PORTS_ERROR = 'routes/Ports/FETCH_PORTS_ERROR'
